export default "/images/strait.svg?1c5251087530fcd3505a33889347a5b1";